//import packages from node modules
import React,{useState, useEffect, useCallback, useRef} from 'react'
import PropTypes from 'prop-types'
import {useSelector, useDispatch} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {reduxForm,Field} from 'redux-form'


//import shared components
import Heading from '../../typography/heading'
import Description from '../../typography/description'
import TextField from '../../form/textfield'
import CustomSlider from '../../slider'
import SolidButton from '../../button/solidbutton'

//import utility functions
import {
  ADD_PRODUCT_PAGE,
  EDIT_PRODUCT_PAGE,
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from '../../../../utilities/function/common'

import {
  getAttributes
} from '../../../../utilities/function/configuration'

import {
  getCID,
  getCurrentStep,
  getDataFromURL,
  getPageByURL
} from '../../../../utilities/function/urlparams'

import {
  getCycle,
  getPriceByBillingCycleName,
} from '../../../../utilities/function/billingCycle'

import { updateConfig, addItemToCart, editProductPage } from '../../../../app/action'

const convertFormValues = values =>{
  const config = []
  if(values && Object.keys(values).length > 0){
    Object.keys(values).forEach((key)=>{
      if(key.indexOf('quantity')===-1){
        let config_id = key.replace('config_','')
        if(config_id){
          config_id = parseInt(config_id)
        }
        const option_id = values[key]
        const getQuantity = () => {
          if(values[key+'_quantity']){
            return values[key+'_quantity']
          }
          return undefined
        }
        const obj = {
          config_id,
          option_id
        }
        if(getQuantity()){
          obj['quantity'] = getQuantity()
        }
        config.push(obj)
      }
    })
  }
  return config
}

let GSuiteSlider = (props) =>{
  const DEFAULT_SEAT = 5
  const {productConfig,configOption} = props
  const [value,setValue] = useState(1)
  const {
    configurations
  } = useSelector(state=>({
    configurations: state.app.configurations
  }))
  const cid = getCID(getDataFromURL(window.location.search))
  const dispatch = useDispatch()
  const getOption = () =>{
    if(configOption && configOption.options && configOption.options.length>0){
      return configOption.options[0]
    }
    return undefined
  }
  const getConfigID = () =>{
    if(configOption && configOption.id){
      return configOption.id
    }
    return undefined
  }
  const getQuantity = () =>{
    if(productConfig && productConfig.config && productConfig.config.length>0){
      const {config} = productConfig
      const currentConfig = config.find(item=>item.config_id===getConfigID())
      if(currentConfig && currentConfig.quantity && parseInt(currentConfig.quantity)){
        return currentConfig.quantity
      }
    }
    return DEFAULT_SEAT
  }

  const config_id = getConfigID()
  const option = getOption()
  const renderSeat = () =>{
    if(option){

      return (
        <div className={'of-gsuite-slider__seat'}>
          <span className={'of-gsuite-slider__seat-number text-font-1-100'}>{value}</span>
          <span className={'of-gsuite-slider__seat-label text-font-1-100'}>{value===1?'Seat':'Seats'}</span>
        </div>
      )
    }

    return (<></>)
  }
  const renderPrice = () =>{
    if(option){
      const {price} = option
      const selectedPrice = getPriceByBillingCycleName(price,'Monthly')
      if(selectedPrice){
        const getTotalPrice = () => {
          if(selectedPrice.price && parseFloat(selectedPrice.price)){
            const total = value * parseFloat(selectedPrice.price)
            if(total){
              return total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
            }
          }
          return undefined
        }
        return (
          <div className={'of-gsuite-slider__price'}>
            <span className={'of-gsuite-slider__price-value text-font-1-100'}>${getTotalPrice()}</span>
            <span className={'of-gsuite-slider__price-label text-font-3-100'}>{getCycle(selectedPrice.name)}</span>
          </div>
        )
      }
    }

    return (<></>)
  }

  return (
    <div className={'of-gsuite-slider clearfix'}>
      <div className={'of-gsuite-slider__wrapper'}>
        {renderSeat()}
        <div className={'of-gsuite-slider__main'}>
          <CustomSlider
            className={'of-slider'}
            min={1}
            max={25}
            value={value}
            tooltip={false}
            onChange={(val)=>{
              setValue(val)
            }}
            onChangeComplete={() => {
              const values = {
                [`config_${config_id}`]: option.id,
                [`config_${config_id}_quantity`]: value
              }
              const config = convertFormValues(values)
              updateConfig(configurations, cid, {
                config
              }, dispatch)
            }}
            setValue={setValue}
            initValue={getQuantity()}
          />
        </div>
        {renderPrice()}
      </div>
      <Field component={TextField} type={'hidden'} name={`config_${config_id}`} initialValue={option.id} readOnly={true}/>
      <Field component={TextField} type={'hidden'} name={`config_${config_id}_quantity`} initialValue={getQuantity()} readOnly={true}/>
    </div>
  )
}

GSuiteSlider.propTypes = {
  productConfig : PropTypes.object,
  configOption: PropTypes.object,
  location: PropTypes.object
}

GSuiteSlider = withRouter(GSuiteSlider)

const getSelectedCofigOption = (config_options,name) =>{
  if(config_options && config_options.length){
    return config_options.find(item=>item.name===name)
  }
  return null
}
let GSuiteConfigForm = (props) =>{
  const {
    configurations
  } = useSelector(state=>({
    configurations: state.app.configurations
  }))

  const {handleSubmit, location} = props
  const pageType = getPageByURL(location.search)
  const cid = getCID(getDataFromURL(location.search))
  const productConfig = configurations[cid]
  const renderSeat = () => {
    if(productConfig && productConfig.selectedProduct && getAttributes(productConfig.selectedProduct)) {
      const {config_options} = getAttributes(productConfig.selectedProduct)
      const selectedConfigOption = getSelectedCofigOption(config_options,'Number of Seats')
      return (
        <GSuiteSlider configOption={selectedConfigOption} productConfig={productConfig}/>
      )
    }
    return (<></>)
  }
  const renderButton = () => {
    if(productConfig && productConfig.billing_cycle_id && productConfig.name ){
      if(pageType === ADD_PRODUCT_PAGE){
        return (
            <div className={'of-gsuite-config-form__row'}>
              <SolidButton type={'submit'} className={'of-gsuite-config-form__button primary-background-1-100'}>Proceed to Cart</SolidButton>
            </div>
        )
      }else if(pageType===EDIT_PRODUCT_PAGE){
        return (
            <div className={'of-gsuite-config-form__row'}>
              <SolidButton type={'submit'} className={'of-gsuite-config-form__button primary-background-1-100'}>Update</SolidButton>
            </div>
        )
      }
    }
    return (
     <></>
    )
  }
  return (
    <form className={'of-gsuite-config-form'} onSubmit={handleSubmit}>
      <div className={'of-gsuite-config-form__row'}>
        {renderSeat()}
      </div>
      {renderButton()}
    </form>
  )
}

GSuiteConfigForm.propTypes = {
  productConfig : PropTypes.object,
  handleSubmit: PropTypes.func,
  location: PropTypes.object
}

GSuiteConfigForm = reduxForm({
  form: 'GSuiteForm'
})(GSuiteConfigForm)
GSuiteConfigForm = withRouter(GSuiteConfigForm)

//main component
let GSuiteConfig = (props) =>{
  const {location,history} = props
  const {
    configurations,
    GSuiteForm,
    cartData
  } = useSelector(state=>({
    configurations: state.app.configurations,
    GSuiteForm: state.form.GSuiteForm,
    cartData: state.app.cartData
  }))
  const cid = getCID(getDataFromURL(location.search))
  const dispatch = useDispatch()
  const pageType = getPageByURL(location.search)


  const getFormValues = useCallback(()=>{
    if(GSuiteForm && GSuiteForm.values){
      return GSuiteForm.values
    }
  },[GSuiteForm])
  const prevFormValues = useRef(null)

  const currentStep = getCurrentStep(configurations,cid)
  const prevStep = useRef(null)

  const updateQuantityCallback = useCallback(()=>{
    const formvalues = getFormValues()
    const config = convertFormValues(formvalues)
    const update = () => {
      if(config && configurations[cid] && configurations[cid].name && configurations[cid].billing_cycle_id){
        updateConfig(configurations,cid,{
          config
        },dispatch)
      }
    }
    if(formvalues && prevFormValues.current !== formvalues){
      update()
      prevFormValues.current = formvalues
    }
    if(currentStep && prevStep.current !== currentStep){
      update()
      prevStep.current = currentStep
    }
  },[getFormValues,configurations,cid,dispatch,currentStep])



  // useEffect(()=>{
  //   updateQuantityCallback()
  // },[updateQuantityCallback])

  const handleConfigForm = (values) => {
    if(pageType===ADD_PRODUCT_PAGE){
      const config = convertFormValues(values)

      if (!Object.prototype.hasOwnProperty.call(configurations[cid], 'config')) {
        updateConfig(configurations, cid, {
          config
        }, dispatch)
        addItemToCart(configurations[cid], dispatch, history, configurations, location)
      } else {
        addItemToCart(configurations[cid],dispatch,history,configurations,location);
      }
    }else if (pageType===EDIT_PRODUCT_PAGE){
      editProductPage(cid,configurations,cartData,dispatch,location,history)
    }
  }
  return (
    <div className={'of-step__wrapper of-gsuite-config'}>
      <Heading className={'of-gsuite-config__heading'}>Seat Quantity</Heading>
      <Description>{`Use the slider below to select the quantity of G Suite seats you'd like.`}</Description>
      <GSuiteConfigForm onSubmit={handleConfigForm} />
    </div>
  )
}

GSuiteConfig.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
}

GSuiteConfig = withRouter(GSuiteConfig)

export default GSuiteConfig